import React, { useState } from "react";
import { useForm } from "react-hook-form";
import uploadImg from "../utils/uploadImageToCloudinary";
import { IoCloseCircleSharp } from "react-icons/io5";
import axios from "axios";
import toast from "react-hot-toast";

function EndTask({ task, id, onClose, getAllTasks }) {
  const [endImages, setEndImages] = useState([]);
  const [loading, setLoading] = useState(false);

  //Initializing react-hook-form
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  //Function to upload multiple images
  const handleImageUpload = async (files) => {
    const fileArray = Array.from(files);
    const uploadedUrls = await Promise.all(
      fileArray.map((img) => uploadImg(img))
    );
    setEndImages((prevUrls) => [...prevUrls, ...uploadedUrls]);
  };

  //Function to remove an image
  const removeImage = (imageIndex) => {
    const newArr = endImages.filter((_, index) => {
      return index !== imageIndex;
    });
    setEndImages(newArr);
  };

  //Function to submit reports and start the work
  const onSubmit = (data) => {
    setLoading(true);

    const finalData = {
      ...data,
      endImages: endImages,
    };

    let config = {
      method: "put",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/task/end-task/${task._id}`,
      headers: {
        "Content-Type": "application/json",
      },
      data: finalData,
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Response of startTask onSubmit: ", response.data);
        setLoading(false);
        onClose();
        toast.success(response.data.message);
        getAllTasks();
      })
      .catch((error) => {
        console.log(error);
        toast.error("Error in starting task");
        setLoading(false);
      });
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4 backdrop-blur-sm backdrop-brightness-75"
      onClick={onClose}
    >
      <div
        className="relative max-h-fit w-full max-w-xl overflow-y-scroll rounded-lg bg-white p-4 shadow-lg md:h-auto md:overflow-y-hidden lg:px-6 lg:py-8"
        onClick={(e) => e.stopPropagation()}
      >
        <h1 className="text-center text-3xl font-bold tracking-wide text-primary">
          End Task
        </h1>

        {/* Input Fields */}
        <form onSubmit={handleSubmit(onSubmit)} className="my-4 gap-4">
          {/* Task Start Note */}
          <div className="my-2 flex flex-col gap-2">
            <label
              htmlFor="startReport"
              className="text-sm font-semibold tracking-wide text-primaryText"
            >
              Task End Note
            </label>

            <textarea
              name="endReport"
              id="endReport"
              placeholder="Leave a note before ending task"
              {...register("endReport")}
              className={`resize-none rounded border bg-transparent px-4 py-2 outline-none focus:ring-1 focus:ring-primary ${
                errors.endReport ? "border-red-500" : "border-gray-800"
              }}`}
            />
          </div>

          {/* Image Upload */}
          <div className="my-2 flex flex-col gap-2">
            <label
              htmlFor="endImages"
              className="text-sm font-semibold tracking-wide text-primaryText"
            >
              Upload Images
            </label>

            <input
              type="file"
              accept="Image/*"
              multiple
              className={`}} rounded border border-gray-800 bg-transparent px-4 py-2 outline-none focus:ring-1
              focus:ring-primary`}
              onChange={(e) => handleImageUpload(e.target.files)}
            />

            <div className="mt-2 flex flex-wrap gap-2">
              {endImages.map((img, index) => (
                <div className="relative w-1/5 p-2">
                  <img
                    key={index}
                    src={img}
                    alt="End image"
                    className="rounded-lg"
                  />
                  <IoCloseCircleSharp
                    size={16}
                    onClick={() => removeImage(index)}
                    className="absolute right-0 top-0 cursor-pointer font-extrabold text-red-500"
                  />
                </div>
              ))}
            </div>
          </div>

          <div className="float-right flex gap-4">
            <button
              type="button"
              className=" rounded bg-gray-400 px-2 py-1 text-sm font-medium tracking-wide shadow-md hover:bg-gray-500 "
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              type="submit"
              className=" rounded bg-red-500 px-2 py-1 text-sm font-medium tracking-wide text-white shadow-md hover:bg-red-700"
            >
              {loading ? <div className="loaderButton"></div> : "End Task"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EndTask;
